import { CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react';

const DataList = ({
    listData,
    listRowsTitles,
    isLoading
}) => {
    const [data, setData] = useState(listData);

    useEffect(() => {
        setData(listData);
    }, [listData]);

    return (
        <TableContainer component={Paper}
            sx={{
                overflowX: "auto",
                mb: 4,
                borderRadius: "0"
            }}
            elevation={0}
        >
            {isLoading ? (
                <div className="w-full flex flex-col 
                justify-center items-center py-8 px-2">
                    <CircularProgress size={30} />
                    <span className="text-primary mt-4 
                       text-lg opacity-animation">
                        صبر کنید...
                    </span>
                </div>
            ) : data ? (
                <Table>
                    <TableHead className="border-b-2 border-b-black">
                        <TableRow>
                            <TableCell
                                align="center"
                                className="border-e w-1/2"
                            >
                                عنوان
                            </TableCell>
                            <TableCell
                                align="center"
                                className="w-1/2"
                            >
                                مقدار
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {listRowsTitles.map((rowTitle, index) => (
                            <TableRow
                                key={`${Math.random()}_${index}`}
                                className="[&:nth-child(2n+1)]:bg-gray-100"
                            >
                                <TableCell
                                    align="center"
                                    className="border-e break-words"
                                >
                                    {rowTitle.text}
                                </TableCell>
                                <TableCell
                                    align="center"
                                    className="break-words"
                                >
                                    {rowTitle.field ? data[rowTitle.field] : rowTitle.element(data)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            ) : (
                <div className="w-full py-10 px-2
                text-lg text-center text-red-500">
                    اطلاعاتی برای نمایش وجود ندارد!
                </div>
            )}
        </TableContainer>
    );
}

export default DataList;
